module.exports = __webpack_public_path__ + "images/rich_heading/other/daily_use/icon_b1fb1e5d15d1e51fc8f06497d4fcc77b.png";